export enum ProductType {
  AXIOMA_W1 = 'axioma_w1',
  INSTALLATION_KIT = 'installation_kit',
  PLUG_AND_PLAY = 'plug_and_play',
  SMART_ELECTRICAL_CABINET = 'smart_electrical_cabinet',
  SPINE_MODULE = 'spine_module',
  VALVE = 'valve',
  RUUVI_TAG = 'ruuvi_tag',
  AURORA = 'aurora',
  SPINE_LOAD = 'spine_load',
  SPINE_MULTI_MEASUREMENT = 'spine_multi_measurement'
}
